import { render, staticRenderFns } from "./MailtoSupport.vue?vue&type=template&id=7acca0da&"
import script from "./MailtoSupport.vue?vue&type=script&lang=js&"
export * from "./MailtoSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports